import { useUserContext } from "../../contexts/UserProvider";
import { useResource } from "../../../services";
import { ParticipantExam } from "../../../types/components";
import { today } from "../../date";
import { createResourceUrl } from "../../data";

export const useEnrolledExams = () => {
  const { user } = useUserContext();
  const { data, mutate, isLoading, isError } = useResource<ParticipantExam[]>(
    createResourceUrl("/common/participant-exam", {
      include: [
        "exam",
        "exam.exam_type",
        "exam.status",
        "exam.responsible_persons",
        "exam.responsible_persons.responsible_person",
      ],
      filters: {
        "eq:participant_id": user?.id,
        "gteDateTime:exam.date_to": today,
        "eq:exam.is_finished": 0,
        "userInsuranceCompany:1": "exam.insurance_company.agents",
        "eq:exam.is_archived": 0,
        "eq:is_completed": 0,
        "eq:exam.status.code": "scheduled",
      },
      sort: "exam.date_from",
    }),
    user,
  );

  return {
    data,
    mutate,
    isLoading,
    isError,
  };
};
